/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { ExternalLink } from 'lucide-react'
import SiteShell from './SiteShell.jsx'
import gridStyles from '../tools/sequoia-tools-grid.module.css'
import { TOOLS, toolHref } from '../data/tools.js'

export default function ToolsHub() {
  return (
    <SiteShell variant="tools">
      <div className={gridStyles.root} dir="rtl">
        <div className={gridStyles.archiveContainer}>
          <header className={gridStyles.archiveHeader}>
            <div className={gridStyles.archiveHeading}>
              <div className={gridStyles.archiveMark}>
                <img src="/a/ico-calc-ico2-83a64147.webp" alt="" className="tbar-icon-img" aria-hidden="true" />
              </div>
              <div>
                <h1>جعبه‌ابزار تمرین و سلامت</h1>
                <p>ابزارهای کاربردی برای سنجش، برنامه‌ریزی و پیگیری مسیر تمرین.</p>
              </div>
            </div>
          </header>
          <div className={gridStyles.toolsGrid}>
            {TOOLS.map((tool) => (
              <article key={tool.slug} className={gridStyles.neuCard}>
                <div className={gridStyles.cardBody}>
                  <div className={gridStyles.cardHeader}>
                    <div className={gridStyles.stickerBox}>
                      <img src={tool.icon} alt="" className={gridStyles.stickerImg} loading="lazy" />
                    </div>
                    <h2>{tool.title}</h2>
                  </div>
                  <div className={gridStyles.cardContent}>
                    <p className={gridStyles.cardDescription}>{tool.desc}</p>
                    <ul className={gridStyles.featureList}>
                      {tool.features.map((f) => (
                        <li key={f} className={gridStyles.featureItem}>
                          <span className={gridStyles.featureIcon}>
                            <img src="/a/checkmark.webp" alt="" aria-hidden="true" />
                          </span>
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className={gridStyles.cardAction}>
                  <a className={gridStyles.neuBtn} href={toolHref(tool)} {...(tool.local ? {} : { target: '_blank', rel: 'noopener' })}>
                    <span>ورود به ابزار</span>
                    {!tool.local && <ExternalLink className={gridStyles.extIcon} size={18} aria-hidden="true" />}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </SiteShell>
  )
}
